module.exports = __webpack_public_path__ + "static/media/WU_STEPS_progress_symbol_inactive.fe67f873.svg";